import {useEffect, useState} from 'react';
import {getBankBalances, getInvoicesForBank} from "../../api/Api";
import {Button, Table, Row} from 'antd';
import {Link} from "react-router";
import {clampToCents} from "../../util/unitutils";

export const BankView = ({refresh, onRefresh, onApiFail, props}) => {
    const [balances, setBalances] = useState([]);

    const [accountFocus, setAccountFocus] = useState(undefined);
    const [accountData, setAccountData] = useState([]);

    useEffect(() => {
        getBankBalances().then(r => {
            const result = r.map(l => {
                return {
                    ...l,
                    key: l.id,
                    amount: l.amount ? l.amount: 0
                }
            })
            console.log(`balances ${JSON.stringify(result)}`);
            setBalances(result);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [refresh, onApiFail]);

    useEffect(() => {
        if (accountFocus === undefined) {
            return;
        }
        getInvoicesForBank(accountFocus).then(r => {
            const result = r.map(l => {
                return {
                    ...l,
                    key: l.id
                }
            }).sort((a, b) => (new Date(b.timestamp)) - (new Date(a.timestamp)))
            console.log(`invoices ${JSON.stringify(result)}`)
            let balance = 0;
            let i;
            for (i=result.length-1; i>=0; i--) {
                const line = result[i];
                balance += parseFloat(line.amount);
                line.balance = clampToCents(balance);
            }
            setAccountData(result);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [onApiFail, accountFocus]);

    const setFocus = (account) => () => {
        setAccountFocus(account);
    }

    const columns = [
        {
            title: 'Bank',
            dataIndex: 'accountName',
            key: 'accountName',
            render: (val, record) => {
                return <div style={{cursor: 'pointer'}} onClick={setFocus(record.id)}>{val}</div>
            }
        },
        {
            title: 'Balance',
            dataIndex: 'amount',
            key: 'amount',
            render: (val, record) => {
                return <div style={{cursor: 'pointer'}} onClick={setFocus(record.id)}>$ {val}</div>
            }
        }
    ]

    const accountColumns = [
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (val) => {
                return `$ ${val}`
            }
        },
        {
            title: 'Confirmed By',
            dataIndex: 'username',
            key: 'username',
            sorter: (a, b) => a.username.toLowerCase().localeCompare(b.username.toLowerCase()),
        },
        {
            title: 'Info',
            dataIndex: 'invoiceNumber',
            key: 'invoiceNumber',
            render: (val, record, index) => {
                // for now test for the existence of the invoice number
                if (val) {
                    return <Link to={`/invoice/${record.invoiceId}`}>{val}</Link>
                } else if (record.notes) {
                    return record.notes;
                } else {
                    // fixme make this better
                    return "Transfer"
                }
            },
            sorter: (a, b) => a.invoiceNumber.toLowerCase().localeCompare(b.invoiceNumber.toLowerCase()),
        },
        {
            title: 'Timestamp',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (val) => (new Date(val)).toString(),// toUtcDateString(new Date(val)),
            sorter: (a, b) => (new Date(a.timestamp))- (new Date(b.timestamp)),
        },
        {
            title: 'Balance',
            dataIndex: 'balance',
            key: 'balance',
            render: (val, record, index) => {
                return `$ ${val}`
            }
        }
    ]

    const cancelDetailView = () => {
        setAccountFocus(undefined);
    }

    const tablePagination = {
        defaultPageSize: 50,
        showSizeChanger: true,
        pageSizeOptions: [50, 100, 150, 200]
    }

    const accountContent = <Table dataSource={balances} columns={columns} />;

    const detailContent = <div>
        <Row><Button onClick={cancelDetailView}>Back</Button></Row>
        <Table dataSource={accountData} columns={accountColumns} pagination={tablePagination}/>
        <Row><Button onClick={cancelDetailView}>Back</Button></Row>
    </div>

    return (accountFocus === undefined) ? accountContent : detailContent;
}